import { IconButton } from "@mui/material"
import { EtiquetaSimplificadaDTO } from "./vendas.model"
import CloseIcon from '@mui/icons-material/Close';
import { Document, Page, PDFViewer, Text, View, Image } from '@react-pdf/renderer';
import { theme } from "theme";

export type TEtiquetaSimplificadaProps = {
    etiquetaSimplificada: EtiquetaSimplificadaDTO,
    onGoBack: () => void
    barCode: string
}


const EtiquetaSimplificada = (props: TEtiquetaSimplificadaProps) => {
    return (
        <>
            <IconButton
                sx={{
                    zIndex: 100000,
                    position: 'absolute',
                    bottom: 20,
                    right: 30,
                    backgroundColor: theme.palette.primary.main,
                    ':hover': {
                        backgroundColor: theme.palette.primary.main,
                        filter: 'grayscale(.2) brightness(.8) contrast(1.5)'
                    }
                }}
                onClick={props.onGoBack}
            >
                <CloseIcon sx={{ color: theme.palette.background.default, fontSize: 45 }} />
            </IconButton>
            <PDFViewer
                style={{
                    zIndex: 10000,
                    width: '100%',
                    height: '100vh',
                    border: 0,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
                showToolbar={true}
            >
                <Document
                    title={props.etiquetaSimplificada.volumes === 1 ? "Etiqueta simplificada" : "Etiquetas Simplificada"}
                    author={''}
                    language='pt-BR'
                >
                    {props.etiquetaSimplificada &&
                        Array.from({ length: props.etiquetaSimplificada.volumes }).map((_, index) => {
                            return (
                                <Page
                                    key={`page-etiqueta-${index}`}
                                    size={{ width: 604.72, height: 377 }}
                                    orientation="landscape"
                                    style={{
                                        backgroundColor: theme.palette.background.default,
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <View style={{
                                        border: "2px solid black",
                                        width: "96%",
                                        height: "96%"
                                    }}>
                                        <View style={{
                                            borderBottomColor: theme.palette.common.black,
                                            borderBottomWidth: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "4px"
                                        }}>
                                            <Text style={{
                                                fontSize: "14px",
                                                fontFamily: 'Helvetica-Bold'
                                            }}>
                                                DANFE SIMPLIFICADO - ETIQUETA
                                            </Text>
                                        </View>
                                        <View style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderBottomColor: theme.palette.common.black,
                                            borderBottomWidth: 2,
                                        }}>
                                            <Text style={{
                                                fontSize: "14px",
                                                marginTop: "3px"
                                            }}>
                                                CHAVE DE ACESSO
                                            </Text>
                                            <Image
                                                src={props.barCode}
                                                style={{
                                                    width: "100%",
                                                    objectFit: 'contain',
                                                }}
                                            />
                                            <Text style={{
                                                fontSize: "10px",
                                                paddingBottom: "10px"
                                            }}>
                                                {props.etiquetaSimplificada.chaveAcesso}
                                            </Text>
                                        </View>
                                        <View style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}>
                                            <Text style={{
                                                fontSize: "14px"
                                            }}>
                                                PROTOCOLO DE AUTORIZAÇÃO
                                            </Text>
                                            <Text style={{
                                                fontSize: "12px",
                                                marginTop: "5px"
                                            }}>
                                                {props.etiquetaSimplificada.protocolo}
                                            </Text>

                                            <View style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                paddingHorizontal: "5px",
                                                borderBottomColor: theme.palette.common.black,
                                                borderBottomWidth: 2,
                                                paddingBottom: "10px",
                                                marginTop: "10px"
                                            }}>
                                                <View>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Tipo de operação:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                        marginTop: "5px"
                                                    }}>
                                                        {props.etiquetaSimplificada.tipoOperacao}
                                                    </Text>
                                                </View>

                                                <View>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Número/Série:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                        marginTop: "5px"
                                                    }}>
                                                        {props.etiquetaSimplificada.numeroSerie}
                                                    </Text>
                                                </View>

                                                <View>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                    }}>
                                                        Emissão:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                        marginTop: "5px"
                                                    }}>
                                                        {props.etiquetaSimplificada.emissao}
                                                    </Text>
                                                </View>
                                            </View>

                                            <Text style={{
                                                fontSize: "14px"
                                            }}>
                                                EMITENTE
                                            </Text>

                                            <View style={{
                                                width: "100%",
                                                justifyContent: "space-between",
                                                paddingHorizontal: "5px",
                                                borderBottomColor: theme.palette.common.black,
                                                borderBottomWidth: 2,
                                                paddingBottom: "10px"
                                            }}>

                                                <View style={{
                                                    marginLeft: "20%",
                                                    marginTop: "5px"
                                                }}>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Nome / Razão social:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                        marginTop: "5px"
                                                    }}>
                                                        {props.etiquetaSimplificada.nomeRazaoSocialEmitente}
                                                    </Text>

                                                    <View style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        marginTop: "10px"
                                                    }}>
                                                        <View style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                        }}>
                                                            <Text style={{
                                                                fontSize: "10px",
                                                            }}>
                                                                CNPJ:
                                                            </Text>

                                                            <Text style={{
                                                                fontSize: "10px",
                                                            }}>
                                                                {""} {props.etiquetaSimplificada.identificacaoEmitente}
                                                            </Text>
                                                        </View>
                                                        <View style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                        }}>

                                                            <Text style={{
                                                                fontSize: "10px",
                                                                marginLeft: "60px"
                                                            }}>
                                                                IE:
                                                            </Text>

                                                            <Text style={{
                                                                fontSize: "10px",
                                                            }}>
                                                                {""} {props.etiquetaSimplificada.inscricaoEstadualEmitente}
                                                            </Text>
                                                        </View>
                                                    </View>


                                                    <View style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        marginTop: "5px"
                                                    }}>

                                                        <Text style={{
                                                            fontSize: "10px",

                                                        }}>
                                                            Telefone:
                                                        </Text>
                                                        <Text style={{
                                                            fontSize: "10px",
                                                        }}>
                                                            {""} {props.etiquetaSimplificada.telefoneEmitente}
                                                        </Text>
                                                    </View>

                                                    <View style={{
                                                        marginTop: "5px"
                                                    }}>
                                                        <Text style={{
                                                            fontSize: "10px"
                                                        }}>
                                                            Endereço:
                                                        </Text>
                                                        <Text style={{
                                                            fontSize: "10px",
                                                            maxWidth: "90%",
                                                            marginTop: "5px"
                                                        }}>
                                                            {props.etiquetaSimplificada.enderecoEmitente}
                                                        </Text>
                                                    </View>
                                                </View>
                                            </View>

                                            <Text style={{
                                                fontSize: "14px"
                                            }}>
                                                DESTINATÁRIO
                                            </Text>

                                            <View style={{
                                                width: "100%",
                                                justifyContent: "space-between",
                                                paddingHorizontal: "5px",
                                                borderBottomColor: theme.palette.common.black,
                                                borderBottomWidth: 2,
                                                paddingBottom: "10px"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px"
                                                }}>
                                                    Nome / Razão social:
                                                </Text>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px"
                                                }}>
                                                    {props.etiquetaSimplificada.nomeRazaoSocialDestinatario}
                                                </Text>

                                                <View style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    marginTop: "10px"
                                                }}>
                                                    <View style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                    }}>
                                                        <Text style={{
                                                            fontSize: "10px"
                                                        }}>
                                                            CPF/CNPJ:
                                                        </Text>

                                                        <Text style={{
                                                            fontSize: "10px",
                                                        }}>
                                                            {""} {props.etiquetaSimplificada.identificacaoDestinatario}
                                                        </Text>
                                                    </View>
                                                    <View style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                    }}>

                                                        <Text style={{
                                                            fontSize: "10px",
                                                            marginLeft: "60px"
                                                        }}>
                                                            IE:
                                                        </Text>

                                                        <Text style={{
                                                            fontSize: "10px",
                                                        }}>
                                                            {props.etiquetaSimplificada.inscricaoEstadualDestinatario}
                                                        </Text>
                                                    </View>
                                                </View>
                                                <View style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    marginTop: "5px"
                                                }}>

                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Telefone:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                    }}>
                                                        {""}  {props.etiquetaSimplificada.telefoneDestinatario}
                                                    </Text>
                                                </View>

                                                <View style={{
                                                    marginTop: "5px"
                                                }}>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Endereço:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px",
                                                        maxWidth: "90%",
                                                        marginTop: "5px"
                                                    }}>
                                                        {props.etiquetaSimplificada.enderecoDestinatario}
                                                    </Text>
                                                </View>
                                            </View>
                                            <View style={{
                                                width: "100%",
                                                paddingHorizontal: "5px",
                                                borderBottomColor: theme.palette.common.black,
                                                borderBottomWidth: 2,
                                                paddingBottom: "10px",
                                                height: "170px"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px"
                                                }}>
                                                    Observações destinadas ao Fisco:
                                                </Text>
                                                <Text style={{
                                                    fontSize: "10px"
                                                }}>
                                                    {props.etiquetaSimplificada.informacaoFisco}
                                                </Text>
                                            </View>

                                            <View style={{
                                                width: "100%",
                                                paddingHorizontal: "5px",
                                                borderBottomColor: theme.palette.common.black,
                                                borderBottomWidth: 2,
                                                paddingBottom: "10px",
                                                display: "flex",
                                                justifyContent: "space-between"

                                            }}>
                                                <View style={{
                                                    display: "flex",
                                                    flexDirection: "row"
                                                }}>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        Transportadora:
                                                    </Text>
                                                    <Text style={{
                                                        fontSize: "10px"
                                                    }}>
                                                        {" "} {props.etiquetaSimplificada.transportadora}
                                                    </Text>

                                                </View>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    textAlign: "right",
                                                    marginTop: "10px"
                                                }}>
                                                    Volume: {index + 1} / {props.etiquetaSimplificada.volumes}
                                                </Text>
                                            </View>

                                        </View>
                                    </View>
                                </Page>
                            )
                        })
                    }
                </Document>
            </PDFViewer >
        </>
    )
}
export default EtiquetaSimplificada
